import styled from "styled-components";


export const StyledAboutGroup = styled.div`
  @media screen and (min-width: 1024px) {
    height: 100vh;
    display: flex;
    align-items: center;
    gap: 50px;
  }
`;

export const StyledAboutContent = styled.div`
  margin-bottom: 5em;

  @media screen and (min-width: 1024px) {
    flex: 0 0 40%;
    margin-bottom: 0;
  }

  @media screen and (min-width: 1440px) {
    flex: 0 0 50%;
  }
`;